import React from "react";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { createNotification } from "./Popup";
import { messages } from "../utility/services/message";
import {
  getAppId,
  getApplicantBirthDate,
  getEmail,
  getDeclarationInfo,
  setTStageID,
  set1BpersonalInfo,
  setEmergenceInfo,
  setAddressInfo,
  setParentInfo,
  setTravelInfo,
} from "../utility/Common";
import {
  applicationManagement,
  applicationManagementMasilingi,
  url,
} from "../utility/services/apiService";
import vigezo_masharti from "../components/documents/vigezo_masharti.pdf";
import Header from "./layout/Header";
import NavBar_appID from "./layout/NavBar_appID";
import Footer from "./layout/Footer";
import CentryReusableComponent from "./CentryReusableComponent";

function Declaration() {
  let navigate = useNavigate();

  const birthDate = getApplicantBirthDate();
  let bellowAge;
  if (birthDate) {
    const birthYear = birthDate.split(" ")[3];
    if (birthYear) {
      bellowAge = new Date().getFullYear() - birthYear;
    }
  }

  const [showModal, setShowModal] = useState(false);
  const handleModalToggle = () => {
    setShowModal(!showModal);
  };

  const [ZanzibarID, setZanzibarID] = useState("");
  const [BirthWardID, setBirthWardID] = useState("");
  const [AnyOtherID, setAnyOtherID] = useState("");
  const [BirthVillage, setBirthVillage] = useState("");

  const [TravelPurposeID, setTravelPurposeID] = useState("");
  const [VisitCountryID, setVisitCountryID] = useState("");
  const [GuardianFullName, setGuardianFullName] = useState("");
  const [GuardianJob, setGuardianJob] = useState("");
  const [GuardianBox, setGuardianBox] = useState("");
  const [GuardianPhoneNumber, setGuardianPhoneNumber] = useState("");
  const [GuardianRelationShip, setGuardianRelationShip] = useState("");
  const [occupatinID, setOccupationID] = useState([]);

  const [FatherFullName, setFatherFullName] = useState("");
  const [MotherFullName, setMotherFullName] = useState("");
  const [FatherDOB, setFatherDOB] = useState("");
  const [MotherDOB, setMotherDOB] = useState("");
  const [FatherDistrictID, setFatherDistrictID] = useState("");
  const [MotherDistrictID, setMotherDistrictID] = useState("");
  const [FatherWard, setFatherBirthWardID] = useState([]);
  const [MotherWard, setMotherBirthWardID] = useState([]);
  const [FatherVillage, setFatherVillage] = useState("");
  const [MotherVillage, setMotherVillage] = useState("");

  const [FirstContactName, setFirstContactName] = useState("");
  const [FirstContactWorkID, setFirstContactWorkID] = useState("");
  const [FirstContactBox, setFirstContactBox] = useState("");
  const [FirstContactPhoneNo, setFirstContactPhoneNo] = useState("");
  const [FirstContactTown, setFirstContactTown] = useState("");
  const [FirstContactStreet, setFirstContactStreet] = useState("");
  const [FirstContactHouseNumber, setFirstContactHouseNumber] = useState("");
  const [FirstContactRelationship, setFirstContactRelationship] = useState("");
  const [SecondContactName, setSecondContactName] = useState("");
  const [SecondContactWorkID, setSecondContactWorkID] = useState("");
  const [SecondContactBox, setSecondContactBox] = useState("");
  const [SecondContactPhoneNo, setSecondContactPhoneNo] = useState("");
  const [SecondContactTown, setSecondContactTown] = useState("");
  const [SecondContactStreet, setSecondContactStreet] = useState("");
  const [SecondContactHouseNo, setSecondContactHouseNo] = useState("");
  const [SecondContactRelationship, setSecondContactRelationship] =
    useState("");
  const { checkApplicationStage } = CentryReusableComponent({});
  const [personalInfos, setPersonalInfos] = useState({});
  const [addressInfos, setAddressInfos] = useState({});
  const [applicationInfos, setApplicationInfos] = useState({});
  const [parentInfos, setParentInfos] = useState({});
  const [travelInfos, setTravelInfos] = useState({});
  const [contactEmergency, setContactEmergency] = useState({});
  const [attachmentInfo, setAttachmentInfo] = useState({});
  const [bioDataInfo, setBioDataInfo] = useState({});
  const [UnderAgeParentInfo, setUnderAgeParentInfo] = useState([]);
  const [isLoading, setIsloading] = useState(false);

  const btnHandler = () => { };

  const [formData, setFormData] = useState({
    ApplicationId: getAppId(),
    EmailAddress: getEmail(),
  });

  const [agree, setAgree] = useState(false);
  const handleChange = (e) => {
    const data = { ...formData };
    data[e.target.name] = e.target.value;
    setFormData(data);
    setAgree(!agree);
  };

  const handleSubmit = (e) => {
    setIsloading(true);
    e.preventDefault();
    btnHandler();
    applicationManagement(formData, "declare").then(
      (result) => {
        setIsloading(false);
        if (result.code == 1) {
          if (result.data) {
            const stID = result?.data[0]?.StageID
            setTStageID(stID)
            navigate("/stp10");
          }
          navigate("/stp10");
        } else if (
          result.code === 3 ||
          result?.message?.toLowerCase().includes("expire")
        ) {
          createNotification({ type: "error", message: "Session expired" })();
          navigate("/");
        } else {
          const msg = result?.message;
          createNotification({ type: "error", message: msg })();
        }
      },
      (error) => {
        setIsloading(false);
        const info = { type: "error", message: messages.networkError };
        createNotification(info)();
      }
    );
  };

  useEffect(() => {
    getDeclarationInfoFromStorage();
  }, []);

  function getDeclarationInfoFromStorage() {
    checkApplicationStage(2)
    const allData = getDeclarationInfo();
    setPersonalInfos(allData?.PersonalInfo && allData?.PersonalInfo[0]);
    setApplicationInfos(allData?.ApplicationInfo && allData?.ApplicationInfo[0]);
    setAddressInfos(allData?.AddressInfo && allData?.AddressInfo[0]);
    setParentInfos(allData?.ParentInfo && allData?.ParentInfo[0]);
    setTravelInfos(allData?.TravelInfo && allData?.TravelInfo[0]);
    setAttachmentInfo(allData?.AttachmentInfo && allData?.AttachmentInfo[0]);
    setBioDataInfo(allData?.BioData && allData?.BioData[0]);
    setUnderAgeParentInfo(
      allData?.UnderAgeParentInfo && allData?.UnderAgeParentInfo[0]
    );
    setContactEmergency(
      allData?.ContactEmergency && allData?.ContactEmergency[0]
    );
  }
  const endeleaBadae = () => {
    navigate("/");
  };
  //--------------------BackStage
  const handleBackStep = (endpoint, formData, routes) => {
    try {
      applicationManagementMasilingi(formData, endpoint).then((result) => {
        if (
          result?.code === 3 ||
          result?.message?.toLowerCase().includes("expire")
        ) {
          createNotification({ type: "error", message: "Session expired" })();
          navigate("/");
        } else if (result?.code === 1 && result?.data.length > 0) {
          if (endpoint == "add_missing_personal_info") {
            set1BpersonalInfo(result?.data[0])
          } else if (endpoint == "add-address-info") {
            setAddressInfo(result.data[0])
          } else if (endpoint == "add-parents-info") {
            setParentInfo(result.data[0])
          } else if (endpoint == "add-travel-info") {
            setTravelInfo(result.data[0])
          } else if (endpoint == "add-emergency-info") {
            setEmergenceInfo(result.data[0])
          }
          const applicationFrom = result?.data[0]?.ApplicationFrom;
          const navigatePath = routes[applicationFrom] || routes.default;
          if (navigatePath) {
            navigate(navigatePath, { state: result?.data[0] });
          } else {
            const info = { type: "error", message: result?.message };
            createNotification(info)();
          }
        } else {
          const info = { type: "error", message: result?.message };
          createNotification(info)();
        }
      });
    } catch (error) {
      const info = { type: "error", message: messages.networkError };
      createNotification(info)();
    }
  };

  const backStp1 = () => {
    const formData = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: "Select",
      BirthVillage,
      BirthWardID,
      ZanzibarID,
      AnyOtherID,
    };

    const routes = {
      3: "/stp1B",
      4: "/stp1",
      5: "/stp1",
      default: null,
    };

    handleBackStep("add_missing_personal_info", formData, routes);
  };

  const backStp2 = () => {
    const formData = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: "Select",
      HouseNumber: "",
      ResidenceDistrictID: "",
      ResidenceVillage: "",
    };

    const routes = {
      default: "/stp2",
    };

    handleBackStep("add-address-info", formData, routes);
  };

  const backStp3 = () => {
    const formData = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: "Select",
      ResidenceDistrictID: "",
      ResidenceVillage: "",
      HouseNumber: "",
      FatherFullName,
      FatherDOB,
      FatherDistrictID,
      FatherWard,
      FatherVillage,
      MotherFullName,
      MotherDOB,
      MotherDistrictID,
      MotherWard,
      MotherVillage,
    };

    const routes = {
      default: "/stp3",
    };

    handleBackStep("add-parents-info", formData, routes);
  };

  const backStp4 = () => {
    const formData = {
      ApplicationId: getAppId(),
      TravellingPurposeID: TravelPurposeID,
      CountryID: VisitCountryID,
      OccupationID: occupatinID,
      EmailAddress: getEmail(),
      Action: "Select",
      GuardianFullName,
      GuardianJob,
      GuardianBox,
      GuardianPhoneNumber,
      GuardianRelationShip,
    };

    const routes = {
      default: "/stp4",
    };

    handleBackStep("add-travel-info", formData, routes);
  };

  const backStp5 = () => {
    const formData = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: "Select",
      FirstContactName,
      FirstContactWorkID,
      FirstContactBox,
      FirstContactPhoneNo,
      FirstContactTown,
      FirstContactStreet,
      FirstContactHouseNumber,
      FirstContactRelationship,
      SecondContactName,
      SecondContactWorkID,
      SecondContactBox,
      SecondContactPhoneNo,
      SecondContactTown,
      SecondContactStreet,
      SecondContactHouseNo,
      SecondContactRelationship,
    };

    const routes = {
      default: "/stp5",
    };

    handleBackStep("add-emergency-info", formData, routes);
  };

  const backStp6 = () => {
    navigate("/stp6");
  };

  return (
    <>
      <Header />
      <div className="container">
        <NavBar_appID />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12 module-content2">
            <div
              className="col-md-12 col-sm-12 col-xs-12 tab-registration-container"
              style={{ marginTop: "-5px" }}
            >
              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 tab-registration-menu hidden-xs">
                <div className="list-group">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      backStp1();
                    }}
                    className="list-group-item done"
                  >
                    Habari Binafsi{" "}
                  </Link>
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      backStp2();
                    }}
                    className="list-group-item done"
                  >
                    Anuwani ya Makazi
                  </Link>
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      backStp3();
                    }}
                    className="list-group-item done"
                  >
                    Habari za Wazazi{" "}
                  </Link>
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      backStp4();
                    }}
                    className="list-group-item done"
                  >
                    Habari za Safari
                  </Link>
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      backStp5();
                    }}
                    className="list-group-item done"
                  >
                    Wakati wa Dharura
                  </Link>
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      backStp6();
                    }}
                    className="list-group-item done"
                  >
                    Viambatanisho{" "}
                  </Link>
                  <Link to="#" className="list-group-item active">
                    Tamko Rasmi{" "}
                  </Link>
                  <Link className="list-group-item ">Malipo </Link>
                </div>
              </div>

              <div
                className="col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-registration-tab"
                style={{ marginTop: "1px", paddingRight: "1px" }}
              >
                <div className="tab-registration-content active">
                  <form id="step-six-form" onSubmit={handleSubmit}>
                    <input type="hidden" name="_csrf" value="" />
                    <div className="card">
                      <div className="box panel panel-default">
                        <div className="callout callout-warning">
                          <p style={{ fontSize: "13px" }}>
                            <strong>ZINGATIA:</strong> Tafadhali hakiki kwa
                            makini taarifa ulizojaza kabla ya kuzithibitisha.
                            Kumbuka, hautoweza kubadilisha taarifa baada ya
                            kuvuka hatua hii.
                          </p>
                        </div>

                        <div className="box panel panel-default">
                          <div className="box-header with-border panel-heading">
                            <i className="fa fa-user"></i>{" "}
                            <h3 className="box-title">Habari Binafsi</h3>
                            <Link
                              onClick={(e) => {
                                e.preventDefault();
                                backStp1();
                              }}
                              className="btn pull-right btn-success btn-xs"
                            >
                              <i className="fa fa-edit"></i> Hariri
                            </Link>{" "}
                          </div>
                          <div className="box-body panel-body">
                            <div className="row">
                              <div className="col-sm-9">
                                <div className="row">
                                  <div className="col-sm-4">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Jina la Kwanza
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {personalInfos?.FirstName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-4">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Jina la Kati
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {personalInfos?.MiddleName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-4">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Jina la Ukoo
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                        }}
                                      >
                                        {personalInfos?.FamilyName}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                                <br />

                                <div className="row">
                                  <div className="col-sm-4">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Jinsia</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {personalInfos?.GenderName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-4">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Namba ya NIDA/Passport
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {applicationInfos?.DocNumber}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-4">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Namba ya ZANID
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {personalInfos?.ZanzibarID}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div className="col-sm-2 declaration-div">
                                {bioDataInfo?.PhotoImage ? (
                                  <img
                                    src={`data:image/jpg;base64,${bioDataInfo.PhotoImage}`}
                                    className="img-thumbnail center-block declaration-image"
                                    style={{ width: "120px", height: "140px" }}
                                  />
                                ) : (<>
                                  {attachmentInfo?.AttachmentPath ? (
                                    <img
                                      src={`${url}get_file?path=${attachmentInfo?.AttachmentPath}`}
                                      className="img-thumbnail center-block declaration-image"
                                      style={{
                                        width: "110px",
                                        height: "130px",
                                      }}
                                    />
                                  ) : (
                                    <p>No image available</p>
                                  )}</>
                                )}


                              </div>


                              <div className="col-sm-12">
                                <div className="strike">
                                  <span>Tarehe na Mahali pa Kuzaliwa</span>
                                </div>
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Tarehe ya Kuzaliwa
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {personalInfos?.ApplicantDoB}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Nchi</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {personalInfos?.CountryName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Eneo</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {personalInfos?.TerritoryName}
                                      </p>
                                    </span>
                                  </div>

                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Mkoa</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {personalInfos?.RegionName}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                                <br />
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Wilaya</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {personalInfos?.DistrictName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Kata/Shehia
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {personalInfos?.WardName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Mtaa/Kijiji
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {personalInfos?.BirthVillage}
                                      </p>
                                    </span>
                                  </div>
                                  <br />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="box panel panel-default">
                          <div className="box-header with-border panel-heading">
                            <i className="fa fa-address-book"></i>{" "}
                            <h3 className="box-title">Anuwani ya Makazi</h3>
                            <Link
                              onClick={(e) => {
                                e.preventDefault();
                                backStp2();
                              }}
                              className="btn pull-right btn-success btn-xs"
                            >
                              <i className="fa fa-edit"></i> Hariri
                            </Link>{" "}
                          </div>
                          <div className="box-body panel-body">
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="strike">
                                  <span>Mawasiliano</span>
                                </div>
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Simu ya Mkononi
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {applicationInfos?.MobileNo}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Barua pepe
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                        }}
                                      >
                                        {applicationInfos?.Email}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                                <br />

                                <div className="strike">
                                  <span>Anuani ya Makazi</span>
                                </div>
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Mkoa</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {addressInfos?.CountryName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Wilaya</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {addressInfos?.DistrictName}
                                      </p>
                                    </span>
                                  </div>
                                        <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Kata/Shehia
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {addressInfos?.WardName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Mtaa/Kijiji
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {addressInfos?.VillageName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Nyumba Na.
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {addressInfos?.HouseNumber}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="box panel panel-default">
                          <div className="box-header with-border panel-heading">
                            <i className="fa fa-users"></i>{" "}
                            <h3 className="box-title">Habari za Wazazi</h3>
                            <Link
                              onClick={(e) => {
                                e.preventDefault();
                                backStp3();
                              }}
                              className="btn pull-right btn-success btn-xs"
                            >
                              <i className="fa fa-edit"></i> Hariri
                            </Link>{" "}
                          </div>
                          <div className="box-body panel-body">
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="strike">
                                  <span>Habari za Baba</span>
                                </div>
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Jina Kamili
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {parentInfos?.FatherFullName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Tarehe ya Kuzaliwa
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {parentInfos?.FatherDOB}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Nchi</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {parentInfos?.FatherCountryName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Eneo</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {parentInfos?.FatherTerritoryName}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                                <br />
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Mkoa</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {parentInfos?.FatherRegionName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Wilaya</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {parentInfos?.FatherDistrictName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Kata/Shehia
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {parentInfos?.FatherWardName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Mtaa/Kijiji
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {parentInfos?.FatherVillage}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                                <br />
                                <div className="strike">
                                  <span>Habari za Mama</span>
                                </div>
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Jina Kamili
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {parentInfos?.MotherFullName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Tarehe</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {parentInfos?.MotherDOB}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Nchi</b>
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {parentInfos?.MotherCountryName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Eneo</b>
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {parentInfos?.MotherTerritoryName}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                                <br />
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Mkoa</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {parentInfos?.MotherRegionName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Wilaya</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {parentInfos?.MotherDistrictName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Kata/Shehia
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {parentInfos?.MotherWardName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Mtaa/Kijiji
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {parentInfos?.MotherVillage}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="box panel panel-default">
                          <div className="box-header with-border panel-heading">
                            <i className="fa fa-plane"></i>{" "}
                            <h3 className="box-title">Habari za Safari</h3>
                            <Link
                              onClick={(e) => {
                                e.preventDefault();
                                backStp4();
                              }}
                              className="btn pull-right btn-success btn-xs"
                            >
                              <i className="fa fa-edit"></i> Hariri
                            </Link>{" "}
                          </div>
                          <div className="box-body panel-body">
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="strike">
                                  <span>Madhumuni ya Safari</span>
                                </div>
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Dhumuni la Safari
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {travelInfos?.Purpose}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Nchi unayokwenda
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {travelInfos?.Country}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Shughuli za Mwombaji
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {travelInfos?.Occupation}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* ====================Bellow Gurdian================== */}
                          <div>
                            {bellowAge !== undefined ||
                              bellowAge !== null ||
                              bellowAge >= 18 ? (
                              <p></p>
                            ) : (
                              <div className="box-body panel-body">
                                <div className="row">
                                  <div className="col-sm-12">
                                    <div className="strike">
                                      <span>
                                        Mzazi / Mlezi (kwa waombaji waliochini
                                        ya umri wa miaka 18)
                                      </span>
                                    </div>
                                    <div className="row">
                                      <div className="col-sm-3">
                                        <span style={{ lineHeight: "1.7em" }}>
                                          <b style={{ fontSize: "13px" }}>
                                            Jina kamili
                                          </b>
                                          <br />
                                          <p
                                            style={{
                                              fontSize: "13px",
                                              textTransform: "uppercase",
                                            }}
                                          >
                                            {
                                              UnderAgeParentInfo?.UnderAgeParentName
                                            }
                                          </p>
                                        </span>
                                      </div>
                                      <div className="col-sm-3">
                                        <span style={{ lineHeight: "1.7em" }}>
                                          <b style={{ fontSize: "13px" }}>
                                            Kazi
                                          </b>
                                          <br />
                                          <p
                                            style={{
                                              fontSize: "13px",
                                              textTransform: "uppercase",
                                            }}
                                          >
                                            {
                                              UnderAgeParentInfo?.UnderAgeParentJob
                                            }
                                          </p>
                                        </span>
                                      </div>
                                      <div className="col-sm-3">
                                        <span style={{ lineHeight: "1.7em" }}>
                                          <b style={{ fontSize: "13px" }}>
                                            Anuani
                                          </b>
                                          <br />
                                          <p
                                            style={{
                                              fontSize: "13px",
                                              textTransform: "uppercase",
                                            }}
                                          >
                                            {
                                              UnderAgeParentInfo?.UnderAgeParentAddress
                                            }
                                          </p>
                                        </span>
                                      </div>
                                      <div className="col-sm-3">
                                        <span style={{ lineHeight: "1.7em" }}>
                                          <b style={{ fontSize: "13px" }}>
                                            Simu ya Mkononi
                                          </b>
                                          <br />
                                          <p style={{ fontSize: "13px" }}>
                                            {
                                              UnderAgeParentInfo?.UnderAgeParentPhone
                                            }
                                          </p>
                                        </span>
                                      </div>
                                    </div>
                                    <br />
                                    <div className="row">
                                      <div className="col-sm-3">
                                        <span style={{ lineHeight: "1.7em" }}>
                                          <b style={{ fontSize: "13px" }}>
                                            Uhusiano
                                          </b>
                                          <br />
                                          <p
                                            style={{
                                              fontSize: "13px",
                                              textTransform: "uppercase",
                                            }}
                                          >
                                            {
                                              UnderAgeParentInfo?.UnderAgeParentRelation
                                            }
                                          </p>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          {/* ========= */}
                        </div>
                        <div className="box panel panel-default">
                          <div className="box-header with-border panel-heading">
                            <i className="fa fa-ambulance"></i>{" "}
                            <h3 className="box-title">Wakati wa Dharura</h3>
                            <Link
                              onClick={(e) => {
                                e.preventDefault();
                                backStp5();
                              }}
                              className="btn pull-right btn-success btn-xs"
                            >
                              <i className="fa fa-edit"></i> Hariri
                            </Link>{" "}
                          </div>
                          <div className="box-body panel-body">
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="strike">
                                  <span>Mtu wa Kwanza wakati wa Dharura</span>
                                </div>
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Jina Kamili
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {contactEmergency?.E1FullName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Kazi</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {contactEmergency?.E1Job}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Sanduku la Posta
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {contactEmergency?.E1Box}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Simu ya Mkononi
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {contactEmergency?.E1PhoneNumber}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                                <br />
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Mji</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {contactEmergency?.E1City}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Mtaa</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {contactEmergency?.E1Street}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Nyumba Na.
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {contactEmergency?.E1HouseNo}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Uhusiano
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {contactEmergency?.E1RelationShip}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                                <br />
                                <div className="strike">
                                  <span>Mtu wa Pili wakati wa Dharura</span>
                                </div>
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Jina Kamili
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {contactEmergency?.E2FullName}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Kazi</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {contactEmergency?.E2Job}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Sanduku la Posta
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {contactEmergency?.E2Box}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Simu ya Mkononi
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {contactEmergency?.E2PhoneNumber}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                                <br />
                                <div className="row">
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Mji</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {contactEmergency?.E2City}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>Mtaa</b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {contactEmergency?.E2Street}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Nyumba Na.
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {contactEmergency?.E2HouseNo}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <span style={{ lineHeight: "1.7em" }}>
                                      <b style={{ fontSize: "13px" }}>
                                        Uhusiano
                                      </b>
                                      <br />
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {contactEmergency?.E2RelationShip}
                                      </p>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="alert alert-info">
                          <button
                            type="button"
                            className="showModalButton btn btn-xs btn-primary pull-right"
                            value="VigezoMasharti"
                            title="Masharti Na Vigezo"
                            onClick={handleModalToggle}
                          >
                            Vigezo na Masharti
                          </button>
                          <p style={{ fontSize: "13px" }}>
                            <strong>ANGALIZO:</strong>&nbsp;tafadhali soma kwa
                            makini vigezo na masharti kabla ya kukubali
                            kuendelea na Ombi ili kuepuka usumbufu baadae.
                          </p>
                        </div>
                        <div
                          className="form-group field-isdeclared"
                          style={{ padding: "5px" }}
                        >
                          <div className="checkbox">
                            <label htmlFor="isdeclared">
                              <input
                                type="checkbox"
                                id="isdeclared"
                                name="StageID"
                                onChange={(e) => handleChange(e)}
                              />
                              <p style={{ fontSize: "13px" }}>
                                Nimehakikisha kuwa taarifa nilizojaza zipo sawa,
                                na nimeelewa vigezo na masharti.
                              </p>
                            </label>
                            <p className="help-block help-block-error"></p>
                          </div>
                        </div>
                        <div className="box-footer">
                          <div className="row">
                            <div className="col-md-4">
                              <Link
                                onClick={(e) => {
                                  e.preventDefault();
                                  backStp6();
                                }}
                                className="btn btn-default btn-block btn-label-next"
                              >
                                <i className="fa fa-angle-double-left"></i> |
                                Hatua Iliyotangulia
                              </Link>
                            </div>
                            <div className="col-md-4">
                              <Link
                                className="btn btn-labeled btn-block btn-default"
                                name="SaveExit"
                                onClick={(e) => {
                                  e.preventDefault();
                                  endeleaBadae();
                                }}
                              >
                                Hifadhi na Toka | <i className="fa fa-save"></i>{" "}
                              </Link>
                            </div>
                            <div className="col-md-4">
                              <button
                                type="submit"
                                className="btn btn-default btn-block btn-label-next"
                                name="SaveNext"
                                disabled={!agree}
                                onClick={handleSubmit}
                              >
                                Hifadhi na Endelea |{" "}
                                <i className="fa fa-angle-double-right"></i>{" "}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>

      {showModal && (
        <div
          className="modal fade show"
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "60%",
            height: "80vh",
            backgroundColor: "#fff",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            zIndex: 1050,
          }}
        >
          <div
            className="modal-content"
            style={{ height: "100%", display: "flex", flexDirection: "column" }}
          >
            <div className="modal-header">
              <h5 className="modal-title">Vigezo na Masharti</h5>
              <button
                type="button"
                className="close"
                onClick={handleModalToggle}
              >
                &times;
              </button>
            </div>
            <div
              className="modal-body"
              style={{
                flex: 1,
                overflowY: "scroll",
                padding: "0",
              }}
            >
              <iframe
                src={vigezo_masharti}
                title="Guidelines PDF"
                style={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                }}
              ></iframe>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={handleModalToggle}>
                Funga
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Declaration;
